<form [formGroup]="form"
      (submit)="onSubmit()">
    <h1 mat-dialog-title
        translate>
        {{ context.isNewEntry ? 'credential_store_modal_add_title' : 'credential_store_modal_edit_title' }}
    </h1>
    <mat-dialog-content>
        <ng-container *uiContentLoading="loadingData$ | async">
            <mat-form-field>
                <ui-suggest [clearable]="false"
                            [disabled]="storeTypeDropdownEntries.length === 1 || !context.isNewEntry"
                            [placeholder]="'credential_store_form_type' | translate"
                            [formControlName]="CredentialStoreControl.type"
                            [items]="storeTypeDropdownEntries"
                            [required]="true"
                            data-cy="credential-stores-modal-list">
                </ui-suggest>
            </mat-form-field>
            <ng-container *ngIf="selectedType.data === CredentialStoreGenericType.SecureStore">
                <mat-form-field *ngLet="form.get(CredentialStoreControl.name) as nameField">
                    <input [formControlName]="CredentialStoreControl.name"
                           [placeholder]="'credential_store_form_name' | translate"
                           matInput
                           required
                           data-cy="credential-stores-modal-name" />
                    <mat-error *ngIf="nameField.hasError('maxlength')"
                               [translateParams]="{
                                    max: nameField.getError('maxlength').requiredLength
                                }"
                               translate>
                        credential_store_form_name_max_length_warning
                    </mat-error>
                </mat-form-field>
                <ng-container *uiContentLoading="loadingDynamicForm$ | async">
                    <ui-dynamic-configuration-form [dynamicFormEntries]="secureStoreConfiguration"
                                                   [form]="additionalConfigurationFormGroup">
                    </ui-dynamic-configuration-form>
                </ng-container>
            </ng-container>
        </ng-container>
    </mat-dialog-content>
    <mat-dialog-actions *ngLet="{
                            loading: loading$ | async
                        } as state"
                        align="end">
        <button mat-button
                mat-dialog-close
                type="button">
            {{ 'modal_action_cancel' | translate }}
        </button>
        <button [disabled]="form.invalid ||
                            state.loading"
                [spinnerButtonLoading]="state.loading"
                ui-spinner-button
                mat-flat-button
                color="primary"
                data-cy="credential-stores-modal-submit"
                type="submit">
            {{ (context.isNewEntry ? 'modal_action_create' : 'modal_action_update') | translate }}
        </button>
    </mat-dialog-actions>
</form>
